import React, { Component } from 'react'
import Axios from 'axios';
import { MDBBtn, MDBIcon, MDBCard, MDBCardBody, MDBContainer, MDBBox, MDBAlert   } from 'mdbreact';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import Modalregister from './Modalregister';
import Modalfinance from './Modalfinance';
import Commentbnlistforuser from './Commentbnlistforuser';
import Commentexlistforuser from './Commentexlistforuser';
import { URL,api } from '../api';
import Modaluserpay from './Modaluserpay';
import Modalregistersm from './Modalregistersm';
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip, PageHeader  } from 'antd';






export default class Homeusersm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: '',
            Psaaword:'',
            modal: false,
            iduser:'',
            article:[],
            articlepay:[],
            url:'https://mua.kpru.ac.th/FrontEnd_Conferencekpru/',
        };
       
        this.submit = this.submit.bind(this);
        this.list = this.list.bind(this);
       // this.toggle = this.toggle.bind(this);
      }


    onTextChange = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }

    submit = (event) => {
        event.preventDefault();

        var datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
        datafrm.append("id", this.state.id);
        datafrm.append("name", this.state.name);
        datafrm.append("lname", this.state.lname);
        datafrm.append("age", this.state.age);
        datafrm.append("sex", this.state.sex);

        if (this.state.update === false) { //เช็คว่าเป็นหน้าสำหรับอัพเดตหรือไม่
            Axios.post('https://conference.kpru.ac.th/PHP/insert.php', datafrm)
                .then((res) => {
                    this.props.history.push('/Customers') //เมื่อบันทึกเสร็จจะทำการให้เปลี่ยนไปที่ path Customers
                })
                .catch((err) => { alert("ไม่สำเร็จ " + err) })

        }
        else {
            Axios.post('https://conference.kpru.ac.th/PHP/update.php', datafrm)
                .then((res) => {
                    this.props.history.push('/Customers') //เมื่อบันทึกเสร็จจะทำการให้เปลี่ยนไปที่ path Customers
                })
                .catch((err) => { alert("ไม่สำเร็จ " + err) }) // เมื่อเกิด error จะมาทำที่คำสั่งนี้แทน
        }

    }

    componentDidMount() {
        this.setState({ iduser: localStorage.getItem('iduser')})


        setTimeout(() => {
            //ภายใน
            api.get('registercon/selectArticlesmconn/'+localStorage.getItem('iduser'))
            .then(res => {
              console.log(res);
            //  this.setState({ bankname: res.data, loading: false })
              this.setState({ article: res.data})
            }) 
      
          }, 0);

        //   setTimeout(() => {
           
        //     api.get('registercon/selectArticleconnpay/'+localStorage.getItem('iduser'))
        //     .then(res => {
        //       console.log(res);
          
        //       this.setState({ articlepay: res.data})
        //     }) 
      
        //   }, 0);

      
    }

    list() {
        this.setState({ iduser: localStorage.getItem('iduser')})


        setTimeout(() => {
            //ภายใน
            api.get('registercon/selectArticlesmconn/'+localStorage.getItem('iduser'))
            .then(res => {
              console.log(res);
            //  this.setState({ bankname: res.data, loading: false })
              this.setState({ article: res.data})
            }) 
      
          }, 0);

        //   setTimeout(() => {
        //     //ภายใน
        //     api.get('registercon/selectArticleconnpay/'+localStorage.getItem('iduser'))
        //     .then(res => {
        //       console.log(res);
        //     //  this.setState({ bankname: res.data, loading: false })
        //       this.setState({ articlepay: res.data})
        //     }) 
      
        //   }, 0);

      
    }


    render() {

        const date = new Date();
        const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
        const dates = day+"-"+month+"-"+year ;

        console.log(dates)


        return (
            <MDBContainer className="mt-1 " fluid>
                <MDBCard>
                    
                    <MDBCardBody>
                        {/* <h1>{this.state.update === true ? <>อัพเดตข้อมูลสมาชิก</> : <>เพิ่มสมาชิก</>}</h1> */}
                      <div className='text-right font-weight-bold'><p>สวัสดีคุณ {localStorage.getItem('nameuser')}</p></div>  
                        
  <div className='mb-2 mt-2'> <Modalregistersm iduser={this.state.iduser} list={this.list} /></div>  
                      {/* <MDBAlert color="success" >
                      <MDBBox tag="p"><h4><strong>รายการลงทะเบียนบทความสัมมนา</strong></h4></MDBBox>
                     </MDBAlert> */}
                         <MDBAlert color="secondary" >
                                    <PageHeader
                                    className="site-page-header"
                                // onBack={() => null}
                                    title="รายการลงทะเบียนบทความสัมมนา"
                                    subTitle=""
                                    avatar={{ src: 'https://cdn.icon-icons.com/icons2/560/PNG/512/Heading-Tag_icon-icons.com_53735.png' }}
                                />
                            </MDBAlert>    
                        
                           

                             <MDBTable bordered responsive small> 
                                    <MDBTableHead color="grey darken-1" textWhite >
                                        <tr>
                                        <th>ลำดับ</th>
                                        <th>ชื่อบทความ</th>
                                        <th>ผู้นำเสนอ</th>
                                        <th>ประเภท</th>
                                        <th>ไฟล์บทความ</th>
                                        {/* <th>ชำระเงินบทความ</th> */}
                                        
                                        {/* <th>หลักฐาน</th> */}
                                        </tr>
                                    </MDBTableHead>
                                    <MDBTableBody>
                                    {this.state.article.map((article,index )  => 
                                    <tr>
                                    <td>{index+1}</td>
                                    <td>{article.name_articlesm}</td>
                                    <td>{article.name_presentsm}</td>
                                    <td>{article.presentype_name}</td>
                                    <td>
                                                        <MDBBtn color="indigo" size="sm" href={`${this.state.url+article.send_uploadeword1sm}`}  target="_blank">WORD</MDBBtn>
                                                        <MDBBtn color="pink" size="sm" href={`${this.state.url+article.send_uploadepdf1sm}`}  target="_blank">PDF</MDBBtn>
                                    </td>
                                     {/* <td>
                                     {article.register_typemamber	=== '3' || article.register_typemamber	=== '4' || article.register_typemamber	=== '5' || article.register_typemamber	=== '6' ?<>

                                     {article.creck	=== '0'?<>
                                        <Modaluserpay id_send={article.id_sendsm} send_id={article.send_id} typeac_id={2} price_typeregister={article.price_typeregister} list={this.list} />
                                     </>:<>
                                     <MDBContainer className='text-left'><a href={`https://e-finance.kpru.ac.th/receipt_research?customer_id=${article.ref1}&receipt_book=${article.BOOK}&receipt_no=${article.NO}`}><MDBBtn color="unique" size='sm'>พิมพ์ใบเสร็จ</MDBBtn></a></MDBContainer> 
                                     </>} 
                                     </>:<>
                                     <p className="teal-text"> ฟรี</p>
                                     </>}
                                      
                                      </td> */}
                                    
                                    {/* <td>
                                        {article.send_status === '1' ?<>
                                       <p className="deep-orange-text"><MDBIcon icon="dna" /> อยู่ระหว่างตรวจสอบ</p> 
                                        </>:<>
                                        {article.send_status === '2' ?<> <p className="teal-text"><MDBIcon icon="check" /> ชำระแล้ว</p></>:<>
                                         <Modalfinance id_send={article.id_send} send_id={article.send_id} send_name={article.send_name} list={this.list}  />
                                        </>}
                                        </> }
                                        
                                         </td> */}
                                    </tr>
                                )}
                           
                                    </MDBTableBody>
                            </MDBTable>


                            {/* <MDBAlert color="success" >
                            <MDBBox tag="p"><h4><strong>ตรวจสอบสถานะบทความ</strong></h4></MDBBox>
                             </MDBAlert>
   

                    <MDBTable bordered responsive>
                        <MDBTableHead color="grey darken-1" textWhite>
                            <tr>
                            <th>ลำดับ</th>
                            <th>ชื่อบทความ</th>
                            <th>ผู้นำเสนอ</th>
                            <th>ประเภท</th>
                            <th>ข้อเสนอแนะบรรณาธิการ</th>
                            <th>ข้อเสนอแนะผู้ทรงคุณวุฒิ</th>
                            <th>สถานะ</th>
                            </tr>
                        </MDBTableHead>
                        <MDBTableBody>
                        {this.state.articlepay.map((articlepay,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{articlepay.name_article}</td>
                        <td>{articlepay.name_present}</td>
                        <td>{articlepay.presentype_name }</td>
                        <td><Commentbnlistforuser  id_send={articlepay.id_send} iduser={this.state.iduser}/></td>
                        <td>
                      
                          <Commentexlistforuser  id_send={articlepay.id_send} iduser={this.state.iduser}/>
                          </td>
                        <td>{articlepay.stapat === '3'?<>    <MDBAlert color="success">
        <a href="#!" className="alert-link">ผ่านการพิจารณา</a>
      </MDBAlert></>:<><MDBAlert color="warning">
        <a href="#!" className="alert-link">อยู่ระหว่างการพิจารณา</a>
      </MDBAlert></>}

      {articlepay.stapat === '3'?<>   
      <MDBBtn color="secondary" size="sm" href={'https://conference.kpru.ac.th/PHPAPI/TCPDF-main/certificate.php?id_sendcf='+articlepay.id_send } target="_blank"> ดาวน์โหลดเกียรติบัตร</MDBBtn>
      </>:<></>}
      </td>
                        </tr>
                      )}
                           
                        </MDBTableBody>
                    </MDBTable> */}



                        {/* <form onSubmit={this.submit}>
                            <div className="mb-2">
                                <label>ชื่อจริง</label>
                                <input className="form-control" onChange={this.onTextChange} name="name"
                                    value={this.state.name} placeholder="กรุณาระบุชื่อจริง" required />
                            </div>

                            <div className="mb-2">
                                <label>นามสกุล</label>
                                <input className="form-control" onChange={this.onTextChange} name="lname"
                                    value={this.state.lname} placeholder="กรุณาระบุนามสกุล" required />
                            </div>

                            <div className="mb-2">
                                <label>อายุ</label>
                                <input type="number" className="form-control" onChange={this.onTextChange} name="age"
                                    value={this.state.age} placeholder="กรุณาระบุอายุ" required />
                            </div>

                            <div className="mb-2">
                                <label>เพศ</label>
                                <input className="form-control" onChange={this.onTextChange} name="sex"
                                    value={this.state.sex} placeholder="กรุณาระบุเพศ" required />
                            </div>

                            <div className="mt-3">
                                <MDBBtn type="submit" color="primary"> <MDBIcon far icon="save" /> บันทึก</MDBBtn>
                            </div>


                        </form> */}
                    </MDBCardBody>
                   <hr/>
                    {/* <img src="https://conference.kpru.ac.th/PHPAPI/rerip.png" className="rounded mx-auto d-block w-50" alt="aligment" /> */}
                </MDBCard>
                </MDBContainer>
        )
    }
}

